
import { Calendar } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const UpcomingEvents = () => {
  const events = [
    { title: "Property Viewing", property: "Seaside Villa", date: "Today, 2:00 PM" },
    { title: "Maintenance Check", property: "Downtown Apt", date: "Tomorrow, 10:00 AM" },
    { title: "Property Viewing", property: "Mountain Retreat", date: "Sep 24, 3:30 PM" },
  ];

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Upcoming Events</CardTitle>
          <Calendar className="h-4 w-4 text-muted-foreground" />
        </div>
        <CardDescription>Property viewings and appointments</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {events.map((event, i) => (
            <div key={i} className="border-l-2 border-propertylk-blue pl-4 py-1">
              <p className="text-sm font-medium">{event.title}</p>
              <p className="text-sm text-muted-foreground">{event.property}</p>
              <p className="text-xs text-muted-foreground">{event.date}</p>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="w-full">View Calendar</Button>
      </CardFooter>
    </Card>
  );
};

export default UpcomingEvents;
